<template>
  <div>
    <div class="container-fluid mt--6 filter-show">
      <div class="card w-100 p-2 mb-2 d-inline-block">
        <div class="d-flex justify-content-between">
          <h5 class="ml-3">Filters</h5>
          <div class="hint-color" style="margin-left: auto; margin-right: 5px;">
            <div>
              <span class="hint" data-toggle="tooltip" data-placement="left"  title="There are bids available for the CUSIP">
                <i class="fa fa-info-circle" style="color: rgb(160 142 255)"></i>
              </span>
            </div>
            <div>
              <span class="hint" data-toggle="tooltip" data-placement="left"  title="Selected Item">
                <i class="fa fa-info-circle" style="color: rgb(238 146 146);"></i>
              </span>
            </div>
            <div>
              <span class="hint" data-toggle="tooltip" data-placement="left"  title="Hidden Item">
                <i class="fa fa-info-circle" style="color: rgb(151 151 151);"></i>
              </span>
            </div>
          </div>
          <h5 class="cursor-pointer" @click="selectColumnOption()" >
            <i class="fa fa-cog"></i>
            Column Options
          </h5>
          <span class="btn btn-link" @click="showFilters = !showFilters">
            <i
              class="fa"
              v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']"
            ></i>
            {{ showFilters ? "Hide" : "Show" }} Filters
          </span>
        </div>
        <div class="row" v-if="showFilters">
          <div class="col-lg-12">
            <form class="row">
              <!-- <div class="col-md-6 col-lg-3">
                    <label>Date</label>
                    <datepicker v-model="currentDate"  name="currentDate" format="MM/dd/yyyy" :clear-button="false" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div> -->
              <div class="col-md-6 col-lg-3">
                <label>CUSIP</label>
                <input
                  style="height: 42px"
                  class="form-control"
                  v-model.trim="searchValue"
                  placeholder="Enter CUSIP"
                />
              </div>   
              <div class="col-md-6 col-lg-3">
                  <label>TRADER</label>
                  <multiselect
                    v-model="filterTrader"
                    placeholder="Select traders"
                    label="firstName"
                    track-by="id"
                    :options="traderList"
                    @input="search"
                    :multiple="false"
                    :limit="3"
                  ></multiselect>
              </div> 
              <div class="col-md-6 col-lg-3">
                <label>ECN</label>
                <multiselect
                  v-model="ecn"
                  placeholder="Select ecn"
                  :options="['IBP', 'TWD', 'TMC']"
                  :multiple="true"
                  @input="search"
                  :limit="3"
                ></multiselect>
              </div>
              <div class="col-md-6 col-lg-3">
                  <label>SAVED SEARCHES</label>
                  <multiselect
                    v-model="savedSearch"
                    placeholder="Select saved searches"
                    label="name"
                    track-by="id"
                    :options="savedSearchList"
                    @input="search"
                    :multiple="false"
                    :limit="3"
                  ></multiselect>
              </div> 
              <div class="col-md-4 col-lg-3 filter-switch">
                <div class="mt-4 text-uppercase">
                  <toggle-button :sync="true" v-model="isShowExpired" @change="search()"/> Include Expired
                  <!-- <input
                    id="checkbox2"
                    type="checkbox"
                    class="form-check-input wh"
                    v-model="isShowExpired"
                  /> -->
                  <!-- <label for="checkbox2" class="form-check-label"
                    >
                  </label> -->
                </div>
              </div>
              <div class="col-md-4 col-lg-4 filter-switch">
                <div class="mt-4 text-uppercase">
                  <toggle-button :sync="true" v-model="isShowAssignedBW" @change="search()"/> Show BW assigned with filter
                  <!-- <input
                    id="isShowAssignedBW"
                    type="checkbox"
                    class="form-check-input wh"
                    v-model="isShowAssignedBW"
                  />
                  <label for="isShowAssignedBW" class="form-check-label"
                    >Show BW assigned with filter
                  </label> -->
                </div>
              </div>
              <div class="col-md-4 col-lg-2 ml-3">
                    <div class="form-check mt-4">
                      <input id="checkbox2" type="checkbox"  class="form-check-input wh" v-model="showFailedLogs" >
                      <label for="checkbox2" class="form-check-label mt-1">SHOW FAILED LOGS</label>
                    </div>
                </div>
                 <div class="col-md-4 col-lg-2 ml-3">
                    <div class="form-check mt-4">
                      <input id="checkbox2" type="checkbox"  class="form-check-input wh" v-model="showPriceSuggested" >
                      <label for="checkbox2" class="form-check-label mt-1">PRICE SUGGESTED</label>
                    </div>
                </div>
              <div class="col-md-6 col-lg-3">
                <button
                  @click="clear()"
                  type="button"
                  class="btn btn-secondary rounded mt-4"
                >
                  Clear
                </button>
                <button
                  @click="search()"
                  type="button"
                  class="btn btn-primary rounded mt-4"
                >
                  Filter
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="abs-btn-grp form-group col-sm-6" style="justify-content: flex-end;">
        <form @submit.prevent="" class="d-inline-flex mt-0 ml-4">
          <div style="
              margin-top: 17px;
              margin-right: 7px;
              color: #fff;
          "><span v-if="isAutoBidderEnabled && autoBidderBoxType === 'BLACK'">
              <toggle-button  :sync="true" v-model="isBlackBoxEnable" @change="onChangeEventHandler(autoBidderBoxType)"/> Start the Day
            </span>
            <span v-if="autoBidderBoxType === 'GREY'" >
              <toggle-button :sync="true" v-model="isGreyBoxEnable" @change="onChangeEventHandler(autoBidderBoxType)"/> Suggest Price
            </span>
          </div>
          <div class="ims-tab ml-0 mt-3">
            <div v-if="isAutoBidderEnabled && autoBidderBoxType === 'BLACK'">
              <button class="btn active" style="padding: 5px;" @click="reRun()" :disabled="!isBlackBoxEnable">
                <i  style="color: #0084cc;margin-top: 0px;" class="fa fa-redo"></i> Rerun
              </button>
            </div>
          </div>
          <div class="ims-tab ml-0 mt-3">
            <div v-if="autoBidderBoxType === 'GREY'">
              <button class="btn active" style="padding: 5px;" @click="reRun()" :disabled="!isGreyBoxEnable">
                <i  style="color: #0084cc;margin-top: 0px;" class="fa fa-redo"></i> Rerun
              </button>
            </div>
          </div>
          <div class="ims-tab ml-0 mt-3">
            <button class="btn active" style="padding: 5px;" @click="getBidwantedList()">
              <i v-if="!loading" style="color: #0084cc;margin-top: 0px;" class="fa">&#xf021;</i> 
              <i v-if="loading" style="color: #0084cc;margin-top: 0px;" class="fa fa-spin">&#xf021;</i> Refresh
            </button>
          </div>
        </form>
      </div>
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader">
                <img src="@/assets/img/loader.svg" alt="" />
              </div>
              <table
                class="table align-items-center table-flush table-hover bidtbl"
                style="min-height: 125px;"
              >
                <thead class="thead-light psticky">
                  <tr>
                    <th v-for="(column,index) in columnHeaders" :key="index" class="sort"
                    v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == column.key  ? 'sort-asc' : '',
                      sortOrder == 'DESC' && sortColumn == column.key  ? 'sort-desc' : '',
                      column.name == 'price' || column.name == 'spread' || column.name == 'yield' || column.name == 'assigned to' ? 'text-left' : 'text-center'
                      ]"  
                    @click="sort(column.key)">
                    <span v-if="column.name == 'assigned to'">
                      ASSIGNED TO <br>
                       <span>Suggested Price - yield</span>
                    </span>
                    <span v-if="column.name != 'assigned to'">{{ column.name  }}</span>
                  </th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="bidwantedList.length == 0 && !loading">
                    <td><p class="nodata">No data available</p></td>
                  </tr>
                  <tr class="cursor-pointer" v-for="(data) in bidwantedList" @click="highlightRow(data)" :key="data.id" v-bind:class="{'row-highlight-red' : data.id == highlightedRow.id,'row-highlight-grey' : data.hidden , 'row-highlight-purple' : data.isTodaysBids && data.id !== highlightedRow.id && !data.hidden}" >
                    
                    <td class="text-center" v-for="(columnValue,index) in columnHeaders" :key="index">
                      <div v-if="columnValue.name == 'description'">
                        {{ data[columnValue.key] }}
                        <span v-if="data.federalTaxStatus === 'SUBJECT_TO_AMT'" class='text-blue'>SUBJECT TO AMT</span><br>
                        <span v-if="data.isTechnicalDefault" class='text-red'>TECHNICAL DEFAULT</span>
                      </div>
                      <div v-else-if="columnValue.name == 'coupon'">
                        {{ data[columnValue.key]  |  percent(3) }}
                      </div>
                      <div v-else-if="columnValue.name == 'cusip'">
                        <span v-if="!data.isNoBidCusip">{{ data[columnValue.key]}}</span>
                        <span v-if="data.isNoBidCusip">
                          <span class="nobid-cusips mb-1">{{ data[columnValue.key]}}</span><br>
                          <span>CUSIP is on the no-bid list.</span>
                        </span>
                      </div>
                      <div v-else-if="columnValue.name == 'put indicator' || columnValue.name == 'sink indicator' ">
                        {{ data[columnValue.key] ? "YES" : "NO" }}
                      </div>
                      <div v-else-if="columnValue.name == 'bond insurer'">
                        {{ getAbbreviation(data[columnValue.key])}}
                      </div>
                      <div v-else-if="columnValue.name == 'issue date' || columnValue.name == 'call date' || columnValue.name == 'maturity date' ||  columnValue.name == 'settlement date'">
                        {{ data[columnValue.key] ? moment(data[columnValue.key]).format("MM/DD/YYYY") : "N/A" }}
                      </div>
                      <div v-else-if="columnValue.name == 'collection details'">
                        <span v-if="data.ecn == 'IBP'"
                        ><span class="maturity">Collecting Until</span> :
                        <span class="">{{
                          data.bidBy
                            ? moment
                                .utc(data.bidBy)
                                .tz('America/New_York')
                                .format("hh:mm:ss a")
                            : "N/A"
                        }} EST</span></span
                      >
                      <span v-if="data.ecn == 'TMC'">
                        <div>
                          <span class="maturity">Collecting Until</span> :
                          <span class="">{{
                            data.bidBy
                              ? moment
                                  .utc(data.bidBy)
                                  .tz('America/New_York')
                                  .format("hh:mm:ss a")
                              : "N/A"
                          }} EST</span>
                        </div>
                        <div>
                          <span class="maturity">Firm Until</span> :
                          <span class="">{{
                            data.firmUntill
                              ? moment
                                  .utc(data.firmUntill)
                                  .tz('America/New_York')
                                  .format("hh:mm:ss a")
                              : "N/A"
                          }} EST</span>
                        </div>
                      </span>
                      <span v-if="data.ecn == 'TWD'">
                        <div>
                          <span class="maturity">Collection Type</span> :
                          <span class="">{{ data.collectionTypeDisplay }}</span>
                        </div>
                        <div>
                          <span class="maturity">Collecting Until</span> :
                          <span class="">{{
                            data.bidBy
                              ? moment
                                  .utc(data.bidBy)
                                  .tz('America/New_York')
                                  .format("hh:mm:ss a")
                              : "N/A"
                          }} EST</span>
                        </div>
                        <div v-if="data.collectionType == 'OPEN'">
                          <span class="maturity">Firm Until</span> :
                          <span class=""
                            >Bid time +{{
                              data.goodForTime
                                ? data.goodForTime / 60 + "Mins"
                                : "N/A"
                            }} EST</span
                          >
                        </div>
                        <div v-if="data.collectionType != 'OPEN'">
                          <span class="maturity">Firm Until</span> :
                          <span class="">{{
                            moment.utc(data.postAtTime)
                              .add(data.goodForTime, "seconds")
                              .tz('America/New_York')
                              .format("hh:mm:ss a")
                          }} EST</span>
                        </div>
                        <div v-if="data.collectionType != 'DEFINEDWOREVIEW' && data.collectionType != 'OPEN'">
                          <span class="maturity">Review Period</span> :
                          <span class=""
                            >{{moment(data.postAtTime).diff(data.bidBy, "minutes")}} Mins 
                          </span>
                        </div>
                      </span>
                      </div>
                      <div v-else-if="columnValue.name == 'assigned to'">
                        <div class="assignedto">
                        <div style="margin-bottom: 3px;" v-for="trader in data.traderList" :key="trader.traderId">
                          <span class="text-dark text-uppercase">{{ trader.firstName }} {{ trader.lastName }}</span>
                          <div>
                            <span  v-if="!trader.idcFailureReason" class="text-success">{{ trader.suggestedPrice | currency }} </span> - <span class="text-info">{{ trader.calculatedYield ? trader.calculatedYield.toFixed(3) : "" }}</span>
                            <span v-if="trader.idcFailureReason" class="text-warning">{{ trader.idcFailureReason }} </span>
                            <!-- <span v-if="trader.idcFailureReason" class="hint" data-toggle="tooltip" data-placement="left"  v-bind:title="trader.idcFailureReason">
                              <i class="fa fa-info-circle" style="color: rgb(160 142 255)"></i>
                            </span> -->
                          </div>
                        </div>
                        <div class="ml-8" v-if="data.isSuggestPriceFailed">
                          <a  data-toggle="tooltip" data-placement="left" title="Failed Log History" @click="toggleFailedLogModal(data)" class="btn ibtn btn-outline-danger"><i class="fas fa-history"></i></a>
                        </div>
                        

                      </div>
                      </div>
                      <div v-else-if="columnValue.name == 'price'">
                        <div>
                          <input :name="'bidprice' + index" v-debounce:300ms="() => priceChanged(data,'',data.bidQuoteAmount)" v-if="isBidIsValid(data.bidBy)" min="0.001" step="0.001" oninput="validity.valid||(value='');" v-on:keyup.enter="checkIfAnyActiveBidwanted(data)"  v-on:click.stop.prevent="" class="form-control form-control-sm" type="number" placeholder="0" v-model="data.bidQuoteAmount">
                          <div style="display: grid;" class="text-dark-red">
                            <span v-if="!data.isMinDenomRegular" >
                              <i  class="fa fa-exclamation-triangle text-dark-red mr-1" aria-hidden="true"></i>Min Denom is not regular.</span>
                            
                            <span v-if="data.isIDCPriceLimitExceed">
                              <i  class="fa fa-exclamation-triangle text-dark-red mr-1" aria-hidden="true"></i>BID Price is out of line - IDC Tolerance.</span>
                            <span v-if="data.isOfferPriceLimitExceed">
                              <i  class="fa fa-exclamation-triangle text-dark-red mr-1" aria-hidden="true"></i>BID Price is out of line - IMS/ARBS Offer Price.</span>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="columnValue.name == 'yield'">
                        <div>
                          <input v-debounce:300ms="() => yieldChanged(data)"   v-on:keyup.enter="checkIfAnyActiveBidwanted(data)"  v-on:click.stop.prevent="" class="form-control form-control-sm" type="number" placeholder="0" v-model="data.calculatedYield">
                        </div>
                      </div>
                      <div v-else-if="columnValue.name == 'spread'">
                        <div>
                          <input v-debounce:300ms="() => spreadChanged(data)"  v-on:keyup.enter="checkIfAnyActiveBidwanted(data)"  v-on:click.stop.prevent="" class="form-control form-control-sm" type="number" placeholder="0" v-model="data.bidByYieldSpread">
                        </div>
                      </div>
                      <div v-else-if="columnValue.name == 'quantity'">
                        <div>
                          {{ data.orderQty }} <br>
                          <span v-if="data.isQtyMultipleFive === false" >
                          <i  class="fa fa-exclamation-triangle text-dark-red mr-1" aria-hidden="true"></i>Bidwanted quantity is not multiple of 5.</span>
                        </div>
                      </div>
                      <div v-else-if="columnValue.name == 'action'" style="display: inline-grid;">
                        <button
                          v-on:click.stop.prevent=""
                          @click="checkIfAnyActiveBidwanted(data)"
                          v-if="isBidIsValid(data.bidBy)"
                          :disabled="!data.bidQuoteAmount || data.expiredBW || loading || data.createdBid || isTraderDisabled || data.complianceBlocked"
                          class="btn btn-success rounded ml-2 mt-0 mb-2"
                          type="button"
                        >
                        <i class="fa fa-gavel" aria-hidden="true"></i>{{data.createdBid ? 'OUT FOR BID' : 'BID'}}
                        </button>
                        <button v-else :disabled="true"
                          class="btn btn-danger rounded ml-2 mt-0 mb-2"
                          type="button"
                        >
                        <i class="fa fa-gavel" aria-hidden="true"></i>EXPIRED
                        </button>
                        <button
                          v-on:click.stop.prevent=""
                          @click="toggleTodayBidsModal(data)"
                          class="btn btn-primary rounded ml-2 mt-0 mb-2"
                          type="button"
                        >
                          <i class="fa fa-paper-plane" aria-hidden="true"></i>TODAY'S BIDS
                        </button>
                        <button
                          v-on:click.stop.prevent=""
                          @click="hideRow(data)"
                          class="btn btn-warning rounded ml-2 mt-0 mb-2"
                          type="button"
                        >
                          <i :class="['fa', data.hidden ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i>{{data.hidden ? 'SHOW' :'HIDE'}}
                        </button>
                        <button
                          v-on:click.stop.prevent=""
                          @click="toggleAccumulaterBidsModal(data)"
                          class="btn rounded ml-2 mt-0 mr-2"
                          :class="[data.isBidExist ? 'btn-info' : 'btn-secondary']" 
                          type="button"
                        >
                          <i class="fa fa-paper-plane" aria-hidden="true"></i>BA BIDS
                        </button>
                        <!-- <button
                          v-on:click.stop.prevent=""
                          @click="toggleFailedLogModal(data)"
                          class="btn rounded ml-2 mt-2 mr-2 btn-info"
                          type="button"
                        >
                          <i class="fa fa-history" aria-hidden="true"></i>FAILED LOGS
                        </button> -->
                        <div style="margin: 10px;" class="text-dark-red" v-if="isTraderDisabled">
                          <span>
                            <i  class="fa fa-exclamation-triangle text-dark-red mr-1" aria-hidden="true"></i>The Risk Manager has disabled bidding</span>
                        </div>
                        <div style="margin: 10px;" class="text-dark-red" v-if="data.complianceBlocked">
                          <span>
                            <i  class="fa fa-exclamation-triangle text-dark-red mr-1" aria-hidden="true"></i>The bidding for this state/rating has been disabled by the risk manager.</span>
                        </div>
                      </div>
                      <div v-else>
                        {{ data[columnValue.key]}}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getBidwantedList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{ totalRows }}</span>
              </div>
            </div>
          </div>
          <SupportData
              v-bind:bidwanted="selectedBidWanted"
              v-if="supportDataModalOpen"
              @close="toggleSupportDataModal()"
              v-on:idcprice="setIdcPrice"
              v-on:offerinecn="setEcnOfferPrice"
            />
            <AutoBidderFailedLogs
              v-bind:bidwanted="selectedBidWanted"
              v-if="failedLogModalOpen"
              @close="toggleFailedLogModal()"
            />
        </div>
      </div>
    </div>
    <SendBidWanted
      v-bind:bidwanted="selectedBidWanted"
      v-if="sendBidWantedModalOpen"
      v-on:close="toggleSendBidWantedModal"
    />
    <TodayBids
      v-bind:bidwanted="selectedCusip"
      v-if="todayBidsModalOpen"
      @close="toggleTodayBidsModal()"
    />
    <AccumulaterBids
      v-bind:bidwanted="selectedCusip"
      v-if="accumulaterbidsModalOpen"
      @close="toggleAccumulaterBidsModal()"
    />
    <ColumnOption
      v-if="showColumnOption"
      @close="selectColumnOption()"
      v-bind:selectedColumnHeaders="columnHeaders"
      v-bind:sortColumn="sortColumn"
      v-bind:sortOrder="sortOrder"
      v-on:applyColumn="applyColumnOption"
    />
    
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import SendBidWanted from "../common/SendBidModal.vue";
import SupportData from "./SupportDataModal.vue";
import TodayBids from "../common/TodaysBidModal.vue";
import AccumulaterBids from "../common/AccumulaterBids.vue";
// import Datepicker from 'vuejs-datepicker';
import stateConstants from "@/stateConstants";
import ColumnOption from "../common/ColumnOptions";
import { defaultColumns} from "@/autobidderDefaultBidColumns";
import AutoBidderFailedLogs from "../AutoBidderFailedLogs";

export default {
  name: "imsCusipComponent",
  components: {
    SendBidWanted,
    SupportData,
    TodayBids,
    ColumnOption,
    AccumulaterBids,
    AutoBidderFailedLogs
  },
  data() {
    return {
      accessToken: null,
      loading: false,
      currentPage: 1,
      perPage: 10,
      searchValue: "",
      totalRows: 0,
      sortColumn: "suggestPrice",
      sortOrder: "ASC",
      bidwantedList: [],
      createdDate: new Date(),
      showFilters: false,
      sendBidWantedModalOpen: false,
      selectedBidWanted: {},
      status: "NEW,BID_CANCELLED",
      statusList: [
        "NEW",
        "BID_CANCELLED"
      ],
      ecn: "",
      supportDataModalOpen: false,
      isShowExpired: false,
      defaultRange : 0,
      idcTollerance : 0,
      isShowAssignedBW : true,
      traderList: [],
      filterTrader: null,
      savedSearch : "",
      savedSearchList: [],
      todayBidsModalOpen: false,
      selectedCusip : "",
      highlightedRow : {},
      bidByYieldSpread : 0,
      isTraderDisabled : false,
      maxQuantity : 0,
      toDaysBidsCount : 0,
      maxQuantitySet : false,
      isBlackBoxEnable : false,
      isGreyBoxEnable : false,
      isAutoBidderEnabled : false,
      stateConstants: stateConstants,
      traderComplianceState : [],
      traderComplianceRating : [],
      autoBidderBoxType : null,
      isBidWantedRefreshed: false,
      columnHeaders : defaultColumns,
      nonSortableColumns : ['action','spread','yield','price','assigned to'],
      showColumnOption : false,
      accumulaterbidsModalOpen : false,
      showFailedLogs : false,
      failedLogModalOpen : false,
      showPriceSuggested : false,

    };
  },
  methods: {
    toggleFailedLogModal(bid){
      if (bid) {
        this.selectedBidWanted = bid;
      }
      this.failedLogModalOpen = !this.failedLogModalOpen

    },
    applyColumnOption(data){
      if(data.selectedHeaders.length)  
      this.columnHeaders = data.selectedHeaders;
      this.setUserSavedColumn(data);
      if(data.sortColumn){
        this.sortColumn = data.sortColumn
      }
      if(data.sortOrder){
        this.sortOrder = data.sortOrder
      }
      this.getBidwantedList();
    },
    selectColumnOption(){
      this.showColumnOption = !this.showColumnOption
    },
    getUser(){
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user?cognitoSub="+
            authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          this.isAutoBidderEnabled = result.data.blackBoxEnabled
        })
    },
    onChangeEventHandler(type){
      if(type === 'BLACK'){
        this.enableBlackboxBidding()
      }
      if(type === 'GREY' && this.isGreyBoxEnable){
        this.isBidWantedRefreshed = false;
        this.saveUserGreyBoxSetting();
        this.startSuggestPrices()
      }
      if(type === 'GREY' && !this.isGreyBoxEnable){
        this.saveUserGreyBoxSetting();
        this.stopSuggestPrices()
      }
    },
    stopSuggestPrices(){
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let data = {
          "greyboxEnabled":  "false",
          "userId": authService.getUser().id,
      }
      this.$http
        .put(
          config.baseUrlAutoBidder +
            "/autobidder/stop-suggest-price",data,
          auth
        )
        .then(() => {})
    },
    startSuggestPrices(){
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let data = {
          "startSuggestPriceFetch": this.isGreyBoxEnable ? "true" : "false",
          "clientName": "drl",
          "cognitoSub": authService.getUser().cognitoSub,
      }
      this.$http
        .post(
          config.baseUrlAutoBidder +
            "/autobidder/start-suggest-price",data,
          auth
        )
        .then(() => {
          // if(!this.isGreyBoxEnable){
          //   this.stopSuggestPrices();
          // }
          
        })
        .catch((e) => {
          console.log(e);
        });
    },
    saveUserGreyBoxSetting(){
      let dataToSend = [
                          {
                              "setting": "ENABLE_GREY_BOX_BIDDING",
                              "dataType": "BOOLEAN",
                              "value": this.isGreyBoxEnable ? "true" : "false",
                              "cognitoSub": authService.getUser().cognitoSub
                          }]
      const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .post(
            config.baseUrlBidSide +
                "/tradebook/setting",dataToSend,
                auth
            )
            .then(() => {})
    },
    reRun(){
      var message = "Are you sure you want to rerun?";
        this.$confirm(message,"Rerun","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          let dataToSend = {"cognitoSub":authService.getUser().cognitoSub}
          const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
                .post(
                config.baseUrlAutoBidder +
                    "/autobidder/rerun",dataToSend,
                    auth
                )
                .then(() => {
                  this.$alert("Rerun successfully started.", "", "success");
                  this.getBidwantedList();
                })
        });      

    },
    saveUserBlackBoxSetting(){
      let dataToSend = [
                          {
                              "setting": "ENABLE_BLACK_BOX_BIDDING",
                              "dataType": "BOOLEAN",
                              "value": this.isBlackBoxEnable ? "true" : "false",
                              "cognitoSub": authService.getUser().cognitoSub
                          }]
      const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .post(
            config.baseUrlBidSide +
                "/tradebook/setting",dataToSend,
                auth
            )
            .then(() => {})
    },
    enableBlackboxBidding(){
      this.saveUserBlackBoxSetting();
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let data = {
          "isBlackBoxActive": this.isBlackBoxEnable ? "true" : "false",
          "clientName": "drl",
          "cognitoSub": authService.getUser().cognitoSub,
      }
      this.$http
        .post(
          config.baseUrlAutoBidder +
            "/autobidder/activate-black-box-bidding",data,
          auth
        )
        .then(() => {
          if(this.isBlackBoxEnable){
            this.$alert("Black Box Bidding Enabled.", "", "success");
          }else{
            this.$alert("Black Box Bidding Disabled.", "", "success");
          }
          
        })
        .catch((e) => {
          console.log(e);
        });
    },
    hideRow(cusipData){
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let hiddenRow ;
      if(cusipData.hidden){
        hiddenRow = false;
      }else{
        hiddenRow = true;
      }
      let data = {"userId":authService.getUser().id,"autoBidBwIds":[cusipData.id],"isHide":hiddenRow}

      this.$http
        .put(
          config.baseUrlAutoBidder +
            "/autobidder/hide-bid",data,
          auth
        )
        .then(() => {
          cusipData.hidden = hiddenRow;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    setIdcPrice(idcPrice){
      console.log(idcPrice)
      this.bidwantedList.forEach((element) => {
        if(element.id === this.selectedBidWanted.id){
          element.idcPrice = idcPrice;
        }
      })
    },
    setEcnOfferPrice(offer){
      this.bidwantedList.forEach((element) => {
        if(element.id === this.selectedBidWanted.id){
          element.ecnSentOfferPrice = offer.price;
        }
      })
    },
    toggleTodayBidsModal(bid){
      if (bid) {
        this.selectedCusip = bid.cusip;
      }
      this.todayBidsModalOpen = !this.todayBidsModalOpen
    },
    toggleAccumulaterBidsModal(bid){
      if (bid) {
        this.selectedCusip = bid.cusip;
      }
      this.accumulaterbidsModalOpen = !this.accumulaterbidsModalOpen
    },
    isBidIsValid(validTime){
      //2023-05-15 20:03:00
      var bidValidTime = this.moment(this.moment.utc(validTime).local().format("YYYY MM DD h:mma"), 'YYYY MM DD h:mma');
      var currentTime = this.moment(this.moment.utc().local().format("YYYY MM DD h:mma"), 'YYYY MM DD h:mma');
      // console.log("Bid valid time",this.moment(bidValidTime).format("YYYY-MM-DD HH:mm:ss"))
      // console.log("current  time",this.moment(currentTime).format("YYYY-MM-DD HH:mm:ss"))
      if(bidValidTime.isAfter(currentTime) ){    
        return true;
      }else{
        return false;
      }

    },
    getTraderList() {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Trader",
          auth
        )
        .then((result) => {
          this.traderList = result.data.content;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getStateName(id) {
      return id ? this.stateConstants.find((x) => x.id === id).short : "N/A";
    },
    getTraderComplainceCheck() {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.loading = true;
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/compliance/zero-conc?traderId="+authService.getUser().id,
          auth
        )
        .then((result) => {
          console.log(result)
          this.traderComplianceState = result.data.stateList;
          this.traderComplianceRating = result.data.ratingList;
          this.getUser();
          //this.traderList = result.data.content;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    toggleSendBidWantedModal(status,bids,currentBid) {
      if (currentBid) {
        this.selectedBidWanted = currentBid;
      }
      if (this.sendBidWantedModalOpen && status === "BIDDED") {
        bids.forEach((bid) => {
          this.bidwantedList.forEach((element) => {
            if(element.id === bid.autoBidBwId){
              element.createdBid = true;
              element.bidQuoteAmount = bid.price;
            }
          })
        })
      }
      this.sendBidWantedModalOpen = !this.sendBidWantedModalOpen;
    },
    toggleSupportDataModal(bid) {
      if (bid) {
        this.selectedBidWanted = bid;
      }
      // this.supportDataModalOpen = false;
      this.supportDataModalOpen = true;
      // window.scrollTo(0, document.body.scrollHeight / 2);

    },
    highlightRow(bid){
      if (bid) {
        this.highlightedRow = bid;
        this.toggleSupportDataModal(bid);
      }
    },
    sort(column) {
      if(this.nonSortableColumns.includes(column)){
        return false
      }
      this.sortColumn = column;
      this.sortOrder =
        this.sortOrder == "ASC"
          ? (this.sortOrder = "DESC")
          : (this.sortOrder = "ASC");
      this.getBidwantedList();
    },
    search() {
      this.currentPage = 1;
      this.getBidwantedList();
    },
    clear() {
      this.searchValue = "";
      this.status = "NEW";
      this.ecn = "";
      this.currentPage = 1;
      this.isShowAssignedBW = true;
      this.filterTrader = null
      this.savedSearch = ""
      this.showPriceSuggested = false
      this.getBidwantedList();
    },
    getBidwantedList() {
      this.loading = true;
      this.bidwantedList = [];
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let currentDate = this.moment.utc().format("YYYY-MM-DD hh:mm:ss a")
      //let fromDate =  this.moment.utc(currentDate).subtract(1,"days").format("YYYY-MM-DD hh:mm:ss a");
      let today = this.moment().format("MM-DD-YYYY");
      let fromDate = this.moment(today).utc().format("YYYY-MM-DD HH:mm:ss")
      if(this.filterTrader) this.isShowAssignedBW = false;
      const assignedBy = this.isShowAssignedBW ? authService.getUser().id : this.filterTrader ? this.filterTrader.id : '';
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=" +
            this.status +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&userId=" +
            "&ecn=" +
            this.ecn +
            "&showExpiredBW=" +
            this.isShowExpired +
            "&currentDate=" +
            currentDate+
            "&assignedBy=" +
            assignedBy+
            "&fromDate="+
            fromDate+
            "&filterId="+
            (this.savedSearch ? this.savedSearch.id : "")+
            "&cognitoSub="+
            authService.getUser().cognitoSub+
            "&loggedUser="+
            authService.getUser().id+
            "&showFailedLog="+this.showFailedLogs+
            "&havingPrice="+this.showPriceSuggested,

          auth
        )
        .then((result) => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach((element) => {
            if (element.collectionType == "OPEN") {
              element.collectionTypeDisplay = "Open";
            }
            if (element.collectionType == "DEFINEDWREVIEW") {
              element.collectionTypeDisplay = "Defined With Review  ";
            }
            if (element.collectionType == "DEFINEDWOREVIEW") {
              element.collectionTypeDisplay = "Defined Without Review";
            }
            element.createdBid = false;
            element.complianceBlocked = false;
            element.calculatedYield = "";
            element.calculatedPrice = "";
            element.ecnSentOfferPrice = "";
            element.isIDCPriceLimitExceed = false;
            element.isOfferPriceLimitExceed = false;
            element.isValidationCheckDone= false;
            element.bidByYieldSpread =  this.bidByYieldSpread ?  this.bidByYieldSpread : 0
            let userId = authService.getUser().id;
            const trader = element.traderList.find(trader => trader.traderId === userId);
            const suggestedPrice = trader ? trader.suggestedPrice : null;
            const suggestedYield = trader ? trader.calculatedYield : null;
            element.priceType = trader ? trader.priceType : null;
            if(suggestedPrice){
              element.bidQuoteAmount = suggestedPrice
            }else{
              element.bidQuoteAmount = ""
            }
            if(suggestedYield){
              element.calculatedYield = suggestedYield ? suggestedYield.toFixed(3) : ""
            }

            if(element.hideForUser && element.hideForUser.length > 0){
              element.hidden = element.hideForUser.includes(authService.getUser().id+"")
            }else{
              element.hidden = false
            }

            let stateName = this.getStateName(element.stateId)
            if(this.traderComplianceState.includes(stateName)) element.complianceBlocked = true
            if(this.traderComplianceRating.includes(element.ratingSP)) element.complianceBlocked = true
          });
          this.bidwantedList = result.data.content;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    getUserSetting(){
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
          .get(
          config.baseUrlBidSide +
              "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
              auth
          )
          .then(result => {
              this.userSettings = result.data;
              this.userSettings.forEach(element => {
                if(element.setting == "AUTOBIDDER_BID_QUANTITY_RANGE"){
                  this.defaultRange = Number(element.value)
                }
                if(element.setting == "BID_PRICE_CHECK_FACTOR"){
                  this.idcTollerance = Number(element.value)
                }
                if(element.setting == "BID_BY_YIELD_SPREAD"){
                  this.bidByYieldSpread = Number(element.value)
                }
                if(element.setting == "AUTOBIDDER_ACTIVE"){
                  this.isTraderDisabled = element.value === "FALSE"
                }
                if(element.setting == "AUTOBIDDER_MAX_QTY"){
                  if(element.value === null || element.value === ""){
                    this.maxQuantitySet = false
                  }else{
                    this.maxQuantitySet = true
                  }
                  this.maxQuantity = Number(element.value)
                }
                if(element.setting == "ENABLE_BLACK_BOX_BIDDING"){
                  this.isBlackBoxEnable = element.value === "true"
                  console.log(this.isBlackBoxEnable)
                }
                if(element.setting == "ENABLE_GREY_BOX_BIDDING"){
                  this.isGreyBoxEnable = element.value === "true"
                  
                }
                if(element.setting == "AUTOBIDDER_BOX_TYPE"){
                  this.autoBidderBoxType = element.value;
                }
              });

              this.getBidwantedList();
        
          })
          .catch(e => {
              console.log(e);
          });
    },
    checkBidQuantityLimitExceed(bidWanted) {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      return this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/bidqty-count?id="+bidWanted.id+"&cognitoSub="+authService.getUser().cognitoSub,
          auth
        )
        .then((result) => {
          this.toDaysBidsCount = result.data;
          let avilableBidQuantityToBid = this.maxQuantity - this.toDaysBidsCount;
          if(this.maxQuantitySet){
            if(avilableBidQuantityToBid < bidWanted.orderQty){
              this.$alert("Max Quantity Limit Exceeded", "", "error");
              this.loading = false;
              return true
            }
          }

          return false
        })
    },
    spreadChanged(data){
      //data.bidQuoteAmount = Number(data.calculatedPrice) - Number(data.bidByYieldSpread)
      this.yieldChanged(data,"spreadchange")
    },
    yieldChanged(bid,spreadUpdated){
      this.loading = true;
      var selectedBidwanted;
      this.bidwantedList.forEach((element) => {
        if(element.id === bid.id){
          selectedBidwanted = element
        }
      })
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
          .get(
          config.baseUrlAutoBidder +
              "/autobidder/calculate-price?cusip="+selectedBidwanted.cusip+"&yield="+selectedBidwanted.calculatedYield,
              auth
          )
          .then(result => {
               if(result.data.calculatedPrice){
                  // bid.calculatedPrice = result.data.calculatedPrice;
                  // bid.bidQuoteAmount = (Number(result.data.calculatedPrice) - Number(bid.bidByYieldSpread)).toFixed(3);
                  this.bidwantedList.forEach((element) => {
                    if(element.id === bid.id){
                      element.calculatedPrice = result.data.calculatedPrice;
                      element.bidQuoteAmount = (Number(result.data.calculatedPrice) - Number(element.bidByYieldSpread)).toFixed(3);
                    }
                  })
                  if(spreadUpdated){
                    this.getCalculatedYield(bid.cusip,bid.bidQuoteAmount,bid.id);
                  }
               }
              this.loading = false
          })
          .catch(e => {
              console.log(e);
              this.loading = false
          });
    },
    priceChanged(cusipData,BID,bidAmount){
      this.getCalculatedYield(cusipData.cusip,bidAmount,cusipData.id);
      if(cusipData.idcPrice){
        if(this.idcTollerance){
          cusipData.isIDCPriceLimitExceed = (cusipData.bidQuoteAmount - cusipData.idcPrice) > (this.idcTollerance);
        }
        this.checkOfferPriceValidation(cusipData,BID);
      }else{
        if(cusipData.priceType != "STATIC"){
          this.getIdcPrice(cusipData);
        }
        this.checkOfferPriceValidation(cusipData,BID);
      }
    },
    checkOfferPriceValidation(cusipData,mode){
      if(cusipData.ecnSentOfferPrice){
        cusipData.isOfferPriceLimitExceed = cusipData.ecnSentOfferPrice < cusipData.bidQuoteAmount;
      }
      else{
        this.getOfferPrice(cusipData,(cusip) =>{
            console.log("Updated cusip",cusip,mode);
            if(mode == "BID" && !cusipData.isValidationCheckDone && !cusip.isOfferPriceLimitExceed && !cusip.isIDCPriceLimitExceed){
              // this.createBid(cusipData)
              this.checkBidQuantityLimitExceed(cusipData).then((isExceed) =>{
                if(!isExceed)
                  this.createBid(cusipData);
                })
            }
            cusipData.isValidationCheckDone = true

        });
      }
    },
    getOfferPrice(cusipData,cb) {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/offer/check-offer-feed-exist?cusip="+cusipData.cusip,
          auth
        )
        .then((result) => {
          let offerInEcn = result.data[0];
          if(offerInEcn){
            cusipData.isOfferPriceLimitExceed = offerInEcn.price < cusipData.bidQuoteAmount;
            cusipData.ecnSentOfferPrice = offerInEcn.price;
          }
          this.loading = false;

          cb(cusipData)
        })
        .catch((e) => {
          console.log("Error", e);
        });
    },
    getIdcPrice(cusipData){
      this.idcApiRunning = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let data = { "cusip": cusipData.cusip, 
                    "fetchAskEval": false,
                    "fetchAmendmentDate":false,
                    "fetchYield":false,
                    "fetchInstMidEval":false,
                    "fetchMidEval":false,
                    "fetchInstBidEval":false,
                    "fetchBidEval":true,
                    "fetchInstAskEval":false,
                    "fetchViaApi" : false,
                    "userId":  authService.getUser().id
                   }
      if(window.location.pathname.includes("/autobidder/supportdata")){
        data.fetchViaApi = true
      }

      this.$http
        .post(
          config.baseUrlAutoBidder +"/rplus/idc-data",data,
          auth
        )
        .then((result) => {
          this.idcApiRunning = false;
          if (result.data) {
            cusipData.idcPrice = result.data.bid.evaluation;
            if(this.idcTollerance)
            cusipData.isIDCPriceLimitExceed = (cusipData.bidQuoteAmount - cusipData.idcPrice)  > (this.idcTollerance)
          }
        })
    },
    getCalculatedYield(cusip,price,id){
      console.log("price",price)
      if(!price) return;
      this.loading = true
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
          .get(
          config.baseUrlAutoBidder +
              "/autobidder/calculate-yield?cusip="+cusip+"&price="+price,
              auth
          )
          .then(result => {
              if(result.data.calculatedYield){
                this.bidwantedList.forEach((element) => {
                  if(element.id === id){
                    element.calculatedYield = result.data.calculatedYield.toFixed(3)
                  }
                })
              }
              this.loading = false
        
          })
          .catch(e => {
              console.log(e);
              this.loading = false
          });
    },
    checkIfAnyActiveBidwanted(data){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let currentDate = this.moment.utc().format("YYYY-MM-DD hh:mm:ss a")
        let today = this.moment().format("MM-DD-YYYY");
        let fromDate = this.moment(today).utc().format("YYYY-MM-DD HH:mm:ss")
        this.loading = true;
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/listall?page=1" +
            "&size=" +
            this.perPage +
            "&search=" +
            data.cusip+
            "&status="+
            this.status+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&currentDate="+
            currentDate+
            "&loggedUser="+
            authService.getUser().id+
            "&fromDate="+
            fromDate,
            auth
        )
        .then(result => {
          let activeBids = result.data.content.filter(bid => bid.id != data.id);
          console.log(activeBids)
          if(activeBids.length > 0){
            this.loading = false;
            this.toggleSendBidWantedModal("","",data)
          }else{
            if(data.isValidationCheckDone){
              this.checkBidQuantityLimitExceed(data).then((isExceed) =>{
                if(!isExceed)
                  this.createBid(data);
                })
            }else{
              this.priceChanged(data,"BID")
            }
          }
          //this.loading = false;
        }).catch(() => this.loading = false);
      
    },
    createBid(bidwanted) {
        this.loading = true;
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        };
        let bidWnatedId = [];
        bidWnatedId.push({
              "autoBidBwId": bidwanted.id,
              "price": bidwanted.bidQuoteAmount,
              "bidByYieldSpread": bidwanted.bidByYieldSpread,
              "yield": bidwanted.calculatedYield,
              "cognitoSub": authService.getUser().cognitoSub

            })
        this.$http
          .post(
            config.baseUrlAutoBidder +
            "/autobidder/sendquote",
            bidWnatedId,
            auth
          )
          .then(() => {
            this.loading = false;
            this.bidwantedList.forEach((element) => {
              if(element.id === bidwanted.id) element.createdBid = true;
            })
          }).catch(() => this.loading = false)
     
    },
    getSavedSearch(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let autoBidType = "SEARCH";
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/filter-listall?page=1&size=50&search=&status=NEW,ACTIVE&sortColumn=id&sortOrder=DESC&userId="+
            authService.getUser().id+
            "&autoBidFilterType="+
            autoBidType,
            auth
        )
        .then(result => {
          this.savedSearchList = result.data.content;
         
        });
    },
    getUserSavedColumn(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/user-column-options-order?cognitoSub="+authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          if(result.data){
            const defaultColumns = result.data;
            if(defaultColumns.selectedHeaders && defaultColumns.selectedHeaders.length)
              this.columnHeaders = defaultColumns.selectedHeaders
            if(defaultColumns.sortColumn){
              this.sortColumn = defaultColumns.sortColumn
            }
            if(defaultColumns.sortOrder){
              this.sortOrder = defaultColumns.sortOrder
            }
          }
          this.getTraderComplainceCheck();
          this.getUserSetting();
          this.getTraderList();
          this.getSavedSearch();
         
        });
    },
    setUserSavedColumn(data){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .post(
           config.baseUrlAutoBidder +
            "/autobidder/column-options-order-save?cognitoSub="+authService.getUser().cognitoSub,data,
            auth
        )
        .then(result => {
          console.log(result.data.content);
         
        });
    },

  },
  mounted() {
    this.getUserSavedColumn();
    this.$root.$on("bidwantedrefresh", () => {
      if (!this.isBidWantedRefreshed) {
        this.isBidWantedRefreshed = true;
        this.getBidwantedList();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("bidwantedrefresh");
  }
};
</script>
<style scoped>

.hint-color { 
  display: flex;
  flex-direction: row;
}
.hint-color div {
  text-align: left;
  font-size: 25px;
  font-weight: 900;
}
.hint-color .hint {
 padding: 5px;
 color: red
}
.hint-color i{
  color: #0087D4;
  font-size: 17px;
}
/* .bidtbl.btn:not(:last-child){
  margin: 10px !important;
} */
.assignedto{
  display: grid;
  /* justify-content: center; */
  text-align: left;
}
.filter-switch{
  margin-left: -6px;
  font-size: 12px;
  color: #292929;
}
.ibtn {
  width: 30px;
  height: 30px;
}
.nobid-cusips {
    background: #e96875;
    border-radius: 50px;
    border: 1px solid #e96875 !important;
    padding: 5px 15px !important;
    margin-top: 20px;
    color: #fff !important;
    display: inline-block;
}
.abs-btn-grp{
  z-index: 0 !important;
}
</style>